(function () {
  console.log("PREVIEW FILE LOADED");

  const scriptUrl =
    (document.currentScript && document.currentScript.src) ||
    (function () {
      const scripts = document.getElementsByTagName("script");
      return scripts.length ? scripts[scripts.length - 1].src : "";
    })();

  const ASSETS_BASE = scriptUrl
    ? scriptUrl.split("/assets/")[0] + "/assets/"
    : "/assets/";

  function norm(v) {
    if (v == null) return "";
    return String(v)
      .trim()
      .toLowerCase()
      .replace(/œ/g, "oe")
      .replace(/æ/g, "ae")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-");
  }

  function assetUrl(filename) {
    return ASSETS_BASE + filename + "?v=" + Date.now();
  }

  const PIERRE_PNG = {
    "cornaline"       : "cornaline",
    "quartz-rose"     : "quartz-rose",
    "agathe-rubanee"  : "agate-rubanee",
    "labradorite"     : "labradorite",
    "oeil-de-tigre"   : "oeil-de-tigre",
    "fluorine"        : "fluorite-verte",
    "fluorite-verte"  : "fluorite-verte",
    "lapis-lazuli"    : "lapis-lazuli",
    "obsidienne-doree": "obsidienne",
    "obsidienne"      : "obsidienne",
    "amethyste"       : "amethyste",
    "amazonite"       : "amazonite",
    "quartz-rutile"   : "quartz-rutile",
    "malachite"       : "malachite",
  };

  const SIGNE_PNG = {
    "belier"     : "belier",
    "taureau"    : "taureau",
    "gemeaux"    : "gemeaux",
    "cancer"     : "cancer",
    "lion"       : "lion",
    "vierge"     : "vierge",
    "balance"    : "balance",
    "scorpion"   : "scorpion",
    "sagittaire" : "sagittaire",
    "capricorne" : "capricorne",
    "verseau"    : "verseau",
    "poisson"    : "poisson",
  };

  function triDirection(element) {
    const el = norm(element);
    return (el === "feu" || el === "air") ? "trianglehaut" : "trianglebas";
  }

  const LAYERS = ["cercle", "pierre", "element", "chiffre", "signe"];

  function buildSrc(state, layer, standalone) {
    const metal   = norm(state?.metal);
    const stone   = norm(state?.stone);
    const sign    = norm(state?.sign);
    const element = norm(state?.element);
    const number  = state?.favNumber != null ? String(state.favNumber).trim() : "";
    const forme   = norm(state?.forme) || "cercle";
    const prefix  = standalone ? "p-" : "";
    /* Suffixe pour visuels dédiés à la forme triangle (point d'accroche différent) —
       ne s'applique jamais à l'écran signature standalone (pas de forme là-bas) */
    const suffix  = (!standalone && forme === "triangle") ? "-triangle" : "";

    if (!metal) return "";

    switch (layer) {

      case "cercle":
        return assetUrl(`${metal}-${forme}.png`);

      case "pierre": {
        if (!stone) return "";
        const stoneFile = PIERRE_PNG[stone] || stone;
        return assetUrl(`${metal}-${stoneFile}${suffix}.png`);
      }

      case "element":
        if (!element) return "";
        return assetUrl(`${prefix}${metal}-${element}${suffix}.png`);

      case "chiffre":
        /* Le chiffre s'affiche si number ET element sont définis */
        if (!number || !element) return "";
        return assetUrl(`${prefix}${number}-${triDirection(element)}${suffix}.png`);

      case "signe": {
        if (!sign) return "";
        const signFile = SIGNE_PNG[sign] || sign;
        return assetUrl(`${prefix}${signFile}${suffix}.png`);
      }

      default:
        return "";
    }
  }

  /* Même chose sans le suffixe -triangle, pour le fallback si le visuel dédié n'existe pas encore */
  function buildSrcFallback(state, layer, standalone) {
    const metal   = norm(state?.metal);
    const stone   = norm(state?.stone);
    const sign    = norm(state?.sign);
    const element = norm(state?.element);
    const number  = state?.favNumber != null ? String(state.favNumber).trim() : "";
    const prefix  = standalone ? "p-" : "";

    switch (layer) {
      case "pierre": {
        if (!stone) return "";
        const stoneFile = PIERRE_PNG[stone] || stone;
        return assetUrl(`${metal}-${stoneFile}.png`);
      }
      case "element":
        if (!element) return "";
        return assetUrl(`${prefix}${metal}-${element}.png`);
      case "chiffre":
        if (!number || !element) return "";
        return assetUrl(`${prefix}${number}-${triDirection(element)}.png`);
      case "signe": {
        if (!sign) return "";
        const signFile = SIGNE_PNG[sign] || sign;
        return assetUrl(`${prefix}${signFile}.png`);
      }
      default:
        return "";
    }
  }

  function updatePreview(state) {
    const stack = document.getElementById("sbx-result-stack");
    if (!stack) {
      console.warn("[Symbolink] stack #sbx-result-stack introuvable");
      return;
    }

    LAYERS.forEach((layer) => {
      const img = stack.querySelector(`img[data-layer="${layer}"]`);
      if (!img) return;

      const src = buildSrc(state, layer);
      const fallback = buildSrcFallback(state, layer);
      console.log("LAYER", layer, "→", src || "(masqué)");

      if (src) {
        if (fallback && fallback !== src) {
          img.onerror = function () {
            img.onerror = function () { img.style.display = "none"; };
            img.src = fallback;
          };
        } else {
          img.onerror = function () { img.style.display = "none"; };
        }
        img.src = src;
        img.style.display = "block";
      } else {
        img.src = "";
        img.style.display = "none";
      }
    });
  }

  window.buildSrc      = buildSrc;
  window.updatePreview = updatePreview;

  console.log("typeof window.updatePreview =", typeof window.updatePreview);
  console.log("PREVIEW FILE FINISHED");

})();(function () {
  console.log("PREVIEW FILE LOADED");

  const scriptUrl =
    (document.currentScript && document.currentScript.src) ||
    (function () {
      const scripts = document.getElementsByTagName("script");
      return scripts.length ? scripts[scripts.length - 1].src : "";
    })();

  const ASSETS_BASE = scriptUrl
    ? scriptUrl.split("/assets/")[0] + "/assets/"
    : "/assets/";

  function norm(v) {
    if (v == null) return "";
    return String(v)
      .trim()
      .toLowerCase()
      .replace(/œ/g, "oe")
      .replace(/æ/g, "ae")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-");
  }

  function assetUrl(filename) {
    return ASSETS_BASE + filename + "?v=" + Date.now();
  }

  const PIERRE_PNG = {
    "cornaline"       : "cornaline",
    "quartz-rose"     : "quartz-rose",
    "agathe-rubanee"  : "agate-rubanee",
    "labradorite"     : "labradorite",
    "oeil-de-tigre"   : "oeil-de-tigre",
    "fluorine"        : "fluorite-verte",
    "fluorite-verte"  : "fluorite-verte",
    "lapis-lazuli"    : "lapis-lazuli",
    "obsidienne-doree": "obsidienne",
    "obsidienne"      : "obsidienne",
    "amethyste"       : "amethyste",
    "amazonite"       : "amazonite",
    "quartz-rutile"   : "quartz-rutile",
    "malachite"       : "malachite",
  };

  const SIGNE_PNG = {
    "belier"     : "belier",
    "taureau"    : "taureau",
    "gemeaux"    : "gemeaux",
    "cancer"     : "cancer",
    "lion"       : "lion",
    "vierge"     : "vierge",
    "balance"    : "balance",
    "scorpion"   : "scorpion",
    "sagittaire" : "sagittaire",
    "capricorne" : "capricorne",
    "verseau"    : "verseau",
    "poisson"    : "poisson",
  };

  function triDirection(element) {
    const el = norm(element);
    return (el === "feu" || el === "air") ? "trianglehaut" : "trianglebas";
  }

  const LAYERS = ["cercle", "pierre", "element", "chiffre", "signe"];

  function buildSrc(state, layer, standalone) {
    const metal   = norm(state?.metal);
    const stone   = norm(state?.stone);
    const sign    = norm(state?.sign);
    const element = norm(state?.element);
    const number  = state?.favNumber != null ? String(state.favNumber).trim() : "";
    const forme   = norm(state?.forme) || "cercle";
    const prefix  = standalone ? "p-" : "";
    /* Suffixe pour visuels dédiés à la forme triangle (point d'accroche différent) —
       ne s'applique jamais à l'écran signature standalone (pas de forme là-bas) */
    const suffix  = (!standalone && forme === "triangle") ? "-triangle" : "";

    if (!metal) return "";

    switch (layer) {

      case "cercle":
        return assetUrl(`${metal}-${forme}.png`);

      case "pierre": {
        if (!stone) return "";
        const stoneFile = PIERRE_PNG[stone] || stone;
        return assetUrl(`${metal}-${stoneFile}${suffix}.png`);
      }

      case "element":
        if (!element) return "";
        return assetUrl(`${prefix}${metal}-${element}${suffix}.png`);

      case "chiffre":
        /* Le chiffre s'affiche si number ET element sont définis */
        if (!number || !element) return "";
        return assetUrl(`${prefix}${number}-${triDirection(element)}${suffix}.png`);

      case "signe": {
        if (!sign) return "";
        const signFile = SIGNE_PNG[sign] || sign;
        return assetUrl(`${prefix}${signFile}${suffix}.png`);
      }

      default:
        return "";
    }
  }

  /* Même chose sans le suffixe -triangle, pour le fallback si le visuel dédié n'existe pas encore */
  function buildSrcFallback(state, layer, standalone) {
    const metal   = norm(state?.metal);
    const stone   = norm(state?.stone);
    const sign    = norm(state?.sign);
    const element = norm(state?.element);
    const number  = state?.favNumber != null ? String(state.favNumber).trim() : "";
    const prefix  = standalone ? "p-" : "";

    switch (layer) {
      case "pierre": {
        if (!stone) return "";
        const stoneFile = PIERRE_PNG[stone] || stone;
        return assetUrl(`${metal}-${stoneFile}.png`);
      }
      case "element":
        if (!element) return "";
        return assetUrl(`${prefix}${metal}-${element}.png`);
      case "chiffre":
        if (!number || !element) return "";
        return assetUrl(`${prefix}${number}-${triDirection(element)}.png`);
      case "signe": {
        if (!sign) return "";
        const signFile = SIGNE_PNG[sign] || sign;
        return assetUrl(`${prefix}${signFile}.png`);
      }
      default:
        return "";
    }
  }

  function updatePreview(state) {
    const stack = document.getElementById("sbx-result-stack");
    if (!stack) {
      console.warn("[Symbolink] stack #sbx-result-stack introuvable");
      return;
    }

    LAYERS.forEach((layer) => {
      const img = stack.querySelector(`img[data-layer="${layer}"]`);
      if (!img) return;

      const src = buildSrc(state, layer);
      const fallback = buildSrcFallback(state, layer);
      console.log("LAYER", layer, "→", src || "(masqué)");

      if (src) {
        if (fallback && fallback !== src) {
          img.onerror = function () {
            img.onerror = function () { img.style.display = "none"; };
            img.src = fallback;
          };
        } else {
          img.onerror = function () { img.style.display = "none"; };
        }
        img.src = src;
        img.style.display = "block";
      } else {
        img.src = "";
        img.style.display = "none";
      }
    });
  }

  window.buildSrc      = buildSrc;
  window.updatePreview = updatePreview;

  console.log("typeof window.updatePreview =", typeof window.updatePreview);
  console.log("PREVIEW FILE FINISHED");

})();